import React from 'react';
import cx from 'classnames';
import s from './ProductPageApp.scss';
import { StateProvider } from '../stores';

import ProductPageBody from '../Components/ProductPageBody/ProductPageBody';

export enum ProductPageAppDataHook {
  root = 'ProductPageAppDataHook.root',
}
function ProductPageApp() {
  const classNames = cx(s.main, s.viewer_classic);

  return (
    <div className={s.container} data-hook={ProductPageAppDataHook.root}>
      <main className={classNames}>
        <StateProvider>
          <ProductPageBody />
        </StateProvider>
      </main>
    </div>
  );
}

export default ProductPageApp;
